import { SerializedStyles, css } from "@emotion/react";

import theme from "../../styles/theme";
import { WatermarkPosition } from "../../types";

const { spacing } = theme;

export const previewContainer = css`
  margin-top: ${spacing(1)}px;
  display: inline-block;
  position: relative;
`;

export const previewImage = css`
  width: 360px;
  height: 202px;
`;

export const floatWatermark = (position?: string, url?: string): SerializedStyles => css`
  position: absolute;
  width: 36px;
  height: 36px;
  display: ${position === WatermarkPosition.RANDOM && "none"};

  top: ${(position === WatermarkPosition.UPPER_LEFT || position === WatermarkPosition.UPPER_RIGHT) && "46px"};
  bottom: ${(position === WatermarkPosition.BOTTOM_LEFT || position === WatermarkPosition.BOTTOM_RIGHT) && "53px"};
  right: ${(position === WatermarkPosition.UPPER_RIGHT || position === WatermarkPosition.BOTTOM_RIGHT) && "16px"};
  left: ${(position === WatermarkPosition.UPPER_LEFT || position === WatermarkPosition.BOTTOM_LEFT) && "16px"};

  background-image: url(${url});
  background-size: cover;
`;
